import { useState } from "react"

import Drawer from "@mui/material/Drawer"
import ListItemText from "@mui/material/ListItemText"
import IconButton from "@mui/material/IconButton"

import ClearIcon from "@mui/icons-material/Clear"

import {
  DrawerBox,
  DrawerBoxHeading,
  Heading,
  TypoHeading,
  GoalHeading,
  ModalHeadingRow,
  ModalHeadingCell,
  GoalHeader,
  GoalHeaderTypo,
  BaseBox,
  SubBaseBox,
  SubBaseBoxText,
  SubBaseDisplayBox,
  GoalsBox,
  EditGoalWrapper,
  EditGoalBox,
  EditGoalBoxTwo,
  EditGoalBoxMax,
} from "./Atom"
import {
  Box,
  Divider,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material"
import { useDispatch, useSelector } from "react-redux"

import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { setOpportunityEditGoalYear } from "../../../redux/slices/metricSlice"
import useAuth from "../../../hooks/useAuth"
import { permissions } from "../../../../config/constants"
import { setLoading } from "../../../redux/slices/appSlice"
import { roundUp } from "../../../../helper/utils/formatting"

function OpportunityEditGoals(props: any) {
  const { isEditGoalsOpen, setIsEditGoalsOpen, updateMonthGoal } = props
  const [editGoalValue, setEditGoalValue] = useState("")
  const [id, setId] = useState("")
  const [isEditGoalFocused, setIsEditGoalFocused] = useState(false)

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(setOpportunityEditGoalYear(event.target.value))
  }

  const dispatch = useDispatch()

  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })

  const officeName = useSelector((state: any) => {
    return state.metric.officeName
  })

  const opportunityName = useSelector((state: any) => {
    return state.metric.opportunityName
  })

  const opportunityEditGoalTable = useSelector((state: any) => {
    return state.metric.opportunityEditGoalTable
  })

  const opportunityAvailableYears = useSelector((state: any) => {
    return state.metric.opportunityAvailableYears
  })

  const opportunitySelectedYear = useSelector((state: any) => {
    return state.metric.opportunityEditGoalYear
  })

  const opportunityEditGoalYear = useSelector((state: any) => {
    return state.metric.opportunityEditGoalYear
  })

  const opportunityGroupSk = useSelector((state: any) => {
    return state.metric.opportunityGroupSk
  })

  const opportunityRegion = useSelector((state: any) => {
    return state.metric.opportunityRegion
  })

  const opportunityPracticeSk = useSelector((state: any) => {
    return state.metric.opportunityPracticeSk
  })

  const opportunityMetricId = useSelector((state: any) => {
    return state.metric.opportunityMetricId
  })

  const date = new Date()
  let CurrentMonth = date.getMonth() + 1
  let CurrentYear = date.getFullYear()

  console.log("opportunityEditGoalTable", opportunityEditGoalTable)

  return (
    <>
      <Drawer
        anchor="right"
        open={isEditGoalsOpen}
        onClose={() => setIsEditGoalsOpen(false)}
        hideBackdrop={true}
      >
        <DrawerBox>
          <DrawerBoxHeading>
            <GoalHeading>Goals</GoalHeading>
            <IconButton
              sx={{ padding: "20px 0px", color: "#000" }}
              disableRipple
              onClick={() => setIsEditGoalsOpen(false)}
            >
              <ClearIcon />
            </IconButton>
          </DrawerBoxHeading>
          <Divider />
          <Box>
            <Heading>
              <Typography sx={{ padding: "20px 0px ", color: "#3C77EF" }}>
                {opportunityName}
              </Typography>
              <TypoHeading>{officeName}</TypoHeading>
            </Heading>
          </Box>
          <Divider />
          <BaseBox>
            {opportunityEditGoalTable?.map((ele: any, index: any) => {
              return (
                <>
                  <Box display={"flex"} key={index}>
                    <SubBaseBox>
                      <SubBaseBoxText>Baseline</SubBaseBoxText>
                      <SubBaseDisplayBox>
                        {ele.baseline_value === null ? (
                          "N/A"
                        ) : (
                          <>
                            {roundUp(
                              ele.baseline_value,
                              ele.goal_type,
                              opportunityEditGoalTable?.metric_precision,
                            )}
                          </>
                        )}
                        {/* {ele.baseline_value === null
                          ? "N/A"
                          : ele.baseline_value} */}
                      </SubBaseDisplayBox>
                    </SubBaseBox>
                    <SubBaseBox>
                      <SubBaseBoxText>Benchmark</SubBaseBoxText>
                      <SubBaseDisplayBox>
                        {ele.metric_benchmark === null ? (
                          "N/A"
                        ) : (
                          <>
                            {roundUp(
                              ele.metric_benchmark,
                              ele.goal_type,
                              opportunityEditGoalTable?.metric_precision,
                            )}
                          </>
                        )}
                        {/* {ele.metric_benchmark === null
                          ? "N/A"
                          : ele.metric_benchmark} */}
                      </SubBaseDisplayBox>
                    </SubBaseBox>
                  </Box>
                </>
              )
            })}
            <SubBaseBox>
              <SubBaseBoxText>Year</SubBaseBoxText>
              <Select
                value={opportunitySelectedYear}
                onChange={handleChange}
                renderValue={(selected) => selected}
                sx={{ width: "140px", height: "40px" }}
                IconComponent={ExpandMoreIcon}
              >
                {opportunityAvailableYears?.map((name: any) => (
                  <MenuItem
                    key={name.year}
                    value={name.year}
                    sx={{ m: "3px 10px", borderRadius: "4px" }}
                  >
                    <ListItemText primary={name.year} />
                  </MenuItem>
                ))}
              </Select>
            </SubBaseBox>
          </BaseBox>

          <GoalHeader>
            <GoalHeaderTypo>Month</GoalHeaderTypo>
            <GoalHeaderTypo
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                padding: "0px",
              }}
            >
              Goal Value
            </GoalHeaderTypo>
          </GoalHeader>

          {opportunityEditGoalTable.length > 0 ? (
            <>
              {Object.entries(opportunityEditGoalTable[0]?.goals).map(
                ([key, value]: any) => {
                  return (
                    <>
                      <GoalsBox key={key}>
                        <GoalsBox>
                          <GoalHeaderTypo>
                            <Typography
                              sx={{
                                color: "#000000",
                                fontSize: "14px",
                                textTransform: "capitalize",
                              }}
                            >
                              {key}-{opportunitySelectedYear}
                            </Typography>
                          </GoalHeaderTypo>

                          {value?.month_id >= CurrentMonth &&
                          opportunitySelectedYear >= CurrentYear &&
                          useAuth({
                            permission: permissions?.UPDATE_GOALS,
                            userPermissions: allPerms,
                          }) ? (
                            <EditGoalWrapper>
                              {!isEditGoalFocused ? (
                                <EditGoalBox>
                                  <Typography
                                    onClick={() => {
                                      setIsEditGoalFocused(true)
                                      setEditGoalValue(
                                        value.goal_value === null
                                          ? "N/A"
                                          : value.goal_value,
                                      )
                                      setId(value.month_id)
                                    }}
                                  >
                                    {value.goal_value === null ? (
                                      "N/A"
                                    ) : (
                                      <>
                                        {roundUp(
                                          value.goal_value,
                                          value.goal_type,
                                          opportunityEditGoalTable?.metric_precision,
                                        )}
                                      </>
                                    )}
                                    {/* {value.goal_value === null
                                      ? "N/A"
                                      : value.goal_value} */}
                                  </Typography>
                                </EditGoalBox>
                              ) : value.month_id === id ? (
                                <>
                                  <EditGoalBoxMax>
                                    <TextField
                                      sx={{
                                        border: "0px",
                                      }}
                                      id="standard-basic"
                                      variant="standard"
                                      inputProps={{
                                        min: 0,
                                        style: {
                                          textAlign: "center",
                                          borderWidth: "0px",
                                        },
                                      }}
                                      value={editGoalValue}
                                      onChange={(event) =>
                                        setEditGoalValue(event.target.value)
                                      }
                                      onBlur={(e) => {
                                        updateMonthGoal({
                                          metric_year: opportunitySelectedYear,
                                          metric_month: value?.month_id,
                                          group_sk: opportunityGroupSk,
                                          region: opportunityRegion,
                                          practice_sk: opportunityPracticeSk,
                                          metric_id: opportunityMetricId,
                                          goal_value: e.target.value,
                                          metric_precision:
                                            opportunityEditGoalTable?.[0]
                                              ?.metric_precision,
                                          goal_type:
                                            opportunityEditGoalTable?.[0]
                                              ?.goal_type,
                                        })
                                        setIsEditGoalFocused(false)
                                        //console.log("e", e.target.value)
                                      }}
                                    />
                                  </EditGoalBoxMax>
                                </>
                              ) : (
                                <EditGoalBox>
                                  <Typography
                                    onClick={() => {
                                      setIsEditGoalFocused(true)
                                      setEditGoalValue(
                                        value.goal_value === null
                                          ? "N/A"
                                          : value.goal_value,
                                      )
                                      setId(value.month_id)
                                    }}
                                  >
                                    {value.goal_value === null ? (
                                      "N/A"
                                    ) : (
                                      <>
                                        {roundUp(
                                          value.goal_value,
                                          value.goal_type,
                                          opportunityEditGoalTable?.metric_precision,
                                        )}
                                      </>
                                    )}
                                    {/* {value.goal_value === null
                                      ? "N/A"
                                      : value.goal_value} */}
                                  </Typography>
                                </EditGoalBox>
                              )}
                            </EditGoalWrapper>
                          ) : (
                            <>
                              {opportunitySelectedYear > CurrentYear ? (
                                <>
                                  <EditGoalWrapper>
                                    {!isEditGoalFocused ? (
                                      <EditGoalBox>
                                        <Typography
                                          onClick={() => {
                                            setIsEditGoalFocused(true)
                                            setEditGoalValue(
                                              value.goal_value === null
                                                ? "N/A"
                                                : value.goal_value,
                                            )
                                            setId(value.month_id)
                                          }}
                                        >
                                          {value.goal_value === null ? (
                                            "N/A"
                                          ) : (
                                            <>
                                              {roundUp(
                                                value.goal_value,
                                                value.goal_type,
                                                opportunityEditGoalTable?.metric_precision,
                                              )}
                                            </>
                                          )}
                                          {/* {value.goal_value === null
                                            ? "N/A"
                                            : value.goal_value} */}
                                        </Typography>
                                      </EditGoalBox>
                                    ) : value.month_id === id ? (
                                      <>
                                        <EditGoalBoxMax>
                                          <TextField
                                            sx={{
                                              border: "0px",
                                            }}
                                            id="standard-basic"
                                            variant="standard"
                                            inputProps={{
                                              min: 0,
                                              style: {
                                                textAlign: "center",
                                                borderWidth: "0px",
                                              },
                                            }}
                                            value={editGoalValue}
                                            onChange={(event) =>
                                              setEditGoalValue(
                                                event.target.value,
                                              )
                                            }
                                            onBlur={(e) => {
                                              updateMonthGoal({
                                                metric_year:
                                                  opportunitySelectedYear,
                                                metric_month: value?.month_id,
                                                group_sk: opportunityGroupSk,
                                                region: opportunityRegion,
                                                practice_sk:
                                                  opportunityPracticeSk,
                                                metric_id: opportunityMetricId,
                                                goal_value: e.target.value,
                                                metric_precision:
                                                  opportunityEditGoalTable?.[0]
                                                    ?.metric_precision,
                                                goal_type:
                                                  opportunityEditGoalTable?.[0]
                                                    ?.goal_type,
                                              })
                                              setIsEditGoalFocused(false)
                                              //console.log("e", e.target.value)
                                            }}
                                          />
                                        </EditGoalBoxMax>
                                      </>
                                    ) : (
                                      <EditGoalBox>
                                        <Typography
                                          onClick={() => {
                                            setIsEditGoalFocused(true)
                                            setEditGoalValue(
                                              value.goal_value === null
                                                ? "N/A"
                                                : value.goal_value,
                                            )
                                            setId(value.month_id)
                                          }}
                                        >
                                          {value.goal_value === null ? (
                                            "N/A"
                                          ) : (
                                            <>
                                              {roundUp(
                                                value.goal_value,
                                                value.goal_type,
                                                opportunityEditGoalTable?.metric_precision,
                                              )}
                                            </>
                                          )}
                                          {/* {value.goal_value === null
                                            ? "N/A"
                                            : value.goal_value} */}
                                        </Typography>
                                      </EditGoalBox>
                                    )}
                                  </EditGoalWrapper>
                                </>
                              ) : (
                                <>
                                  <EditGoalWrapper>
                                    <EditGoalBoxTwo>
                                      {value.goal_value === null ? (
                                        "N/A"
                                      ) : (
                                        <>
                                          {roundUp(
                                            value.goal_value,
                                            value.goal_type,
                                            opportunityEditGoalTable?.metric_precision,
                                          )}
                                        </>
                                      )}
                                      {/* {value.goal_value === null
                                        ? "N/A"
                                        : value.goal_value} */}
                                    </EditGoalBoxTwo>
                                  </EditGoalWrapper>
                                </>
                              )}
                            </>
                          )}
                        </GoalsBox>
                      </GoalsBox>
                    </>
                  )
                },
              )}
            </>
          ) : (
            ""
          )}
        </DrawerBox>
      </Drawer>
    </>
  )
}

export default OpportunityEditGoals
